// extracted by mini-css-extract-plugin
export var alignCenter = "_9c-d";
export var bannerShown = "_9c-6";
export var buttonContent = "_9c-0";
export var cardList = "_9c-1";
export var centerContent = "_9c-2";
export var chevron = "_9c-3";
export var closePanelButton = "_9c-k";
export var conversationContextContainer = "_9c-l";
export var conversationDetailContainer = "_9c-4";
export var detailWrapper = "_9c-7";
export var dropdownButton = "_9c-e";
export var dropdownTitle = "_9c-9";
export var fullHeight = "_9c-5";
export var hidden = "_9c-a";
export var icon = "_9c-b";
export var mergeSuggestionWrapper = "_9c-m";
export var panel = "_9c-i";
export var portalButtonsWrapper = "_9c-c";
export var right = "_9c-j";
export var tableSummaryContainer = "_9c-8";
export var tableSummaryHeader = "_9c-g";
export var threeDotsButton = "_9c-f";
export var wide = "_9c-h";